import React, { createElement } from 'react';
import { motion } from 'framer-motion';
import { Eye, Calculator, Camera, Megaphone, MessageCircle, FileText, KeyRound, Wallet } from 'lucide-react';
const services = [{
  icon: Eye,
  label: 'Pregled vozila',
  description: 'Strokoven pregled stanja'
}, {
  icon: Calculator,
  label: 'Cenitev',
  description: 'Realna tržna ocena'
}, {
  icon: Camera,
  label: 'Fotografiranje',
  description: 'Profesionalne fotografije'
}, {
  icon: Megaphone,
  label: 'Objava',
  description: 'Predstavitev kupcem'
}, {
  icon: MessageCircle,
  label: 'Komunikacija s kupci',
  description: 'Odgovarjanje na vprašanja'
}, {
  icon: FileText,
  label: 'Dokumentacija',
  description: 'Priprava vseh papirjev'
}, {
  icon: KeyRound,
  label: 'Prenos lastništva',
  description: 'Uradno prevzem vozila'
}, {
  icon: Wallet,
  label: 'Plačilo',
  description: 'Varno nakazilo kupnine'
}];
export function WeHandleEverything() {
  return;
}